import script from "./PrivatePlansPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivatePlansPage.vue?vue&type=script&setup=true&lang=js"

import "./PrivatePlansPage.vue?vue&type=style&index=0&id=5ce3a04f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ce3a04f"]])

export default __exports__